import type React from 'react';
import styled from '@emotion/styled';
import { ColorOptionWithIcon } from '../NoColorButton';
import { Tooltip, useTheme } from '@mui/material';
import { Colorize as PickColorIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type StyledButtonProps = {
  iconColor: string | null;
};

const StyledButton = styled(ColorOptionWithIcon)<StyledButtonProps>(
  ({ theme, color, iconColor }) => ({
    backgroundColor:
      color === 'transparent' ? theme.palette.action.selected : undefined,
    '.MuiSvgIcon-root': {
      color: iconColor ?? undefined,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? 'black' : undefined,
  })),
);

type CustomColorButtonProps = {
  customColor: string | null;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const CustomColorButton = ({
  customColor,
  onClick,
}: CustomColorButtonProps) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={
        <FormattedMessage id="portfolio.challenge.color_picker.color_options.custom_color" />
      }
    >
      <StyledButton
        color={customColor ?? 'transparent'}
        iconColor={
          customColor !== null
            ? theme.palette.getContrastText(customColor)
            : null
        }
        onClick={onClick}
      >
        <PickColorIcon fontSize="small" />
      </StyledButton>
    </Tooltip>
  );
};

export default CustomColorButton;
